import config from 'config'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import styles from './styles.module.scss'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import BackNavigation from 'srcReact/components/common2/BackNavigation'
import Spinner from 'srcReact/components/common2/Spinner'
import Tabs from 'srcReact/components/common2/Tabs'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { checkNested } from 'srcReact/helpers/validator'
import { moderationReportActions } from 'srcReact/ModerationReportPage'
import { urlSearchParams } from 'srcReact/helpers/utils'
import history, { historyReplaceState } from 'srcReact/helpers/history'
import WorkplaceActivity from './components/WorkplaceActivity'
import AwaitingReview from './components/AwaitingReview'
import ReviewHistory from './components/ReviewHistory'
import queryString from 'query-string'

const ModerationReportPage = (props) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const {
    common: { isNative },
    moderationReport: { loading, loaded, error, moderation_rights, moderation_stats, moderation_data, reload },
    organization: { current_organization }
  } = useSelector((state) => state)
  const [activeTab, setActiveTab] = useState(props.match.params.mixrId)
  const [filter, setFilter] = useState('all')
  const [searchText, setSearchText] = useState('')
  const [isTabActive, setIsTabActive] = useState(false)

  useEffect(() => {
    const { tab } = queryString.parse(history.location.search)
    switch (tab) {
      case 'workplace_activity':
        setActiveTab(0)
        break
      case 'awaiting_review':
        setActiveTab(1)
        break
      case 'history':
        setActiveTab(2)
        break
      default:
        setActiveTab(0)
        break
    }
  }, [])
  useEffect(() => {
    if (!isTabActive && moderation_data.posts?.length === 0) {
      setIsTabActive(true)
      handleSetActiveTab(2, 'history')
    }
  }, [isTabActive, moderation_data])
  useEffect(() => {
    if (isNative) {
      dispatch(
        moderationReportActions.getInfo(
          urlSearchParams('organization_id'),
          Object.keys(t('moderationReport.tabs', { returnObjects: true }))[activeTab],
          filter !== 'all' ? filter.slice(0, -1) : filter,
          searchText
        )
      )
      return
    }
    if (checkNested(current_organization, 'info', 'id')) {
      dispatch(
        moderationReportActions.getInfo(
          current_organization.info.id,
          Object.keys(t('moderationReport.tabs', { returnObjects: true }))[activeTab],
          filter !== 'all' ? filter.slice(0, -1) : filter,
          searchText
        )
      )
    }
  }, [
    current_organization && current_organization.info && current_organization.info.id,
    activeTab,
    filter,
    searchText,
    reload
  ])

  const handleSetActiveTab = (tabNum, tabName) => {
    setActiveTab(tabNum)
    historyReplaceState(`/0/moderation/?tab=${tabName}`)
  }

  return (
    <PageContainer
      pageClassName={styles.moderationReportPageContainer}
      pageTitle={t('moderationReport.title')}
      withSidebar={true}
      withFooter={false}>
      <div className={styles.moderationReportPageWrapper}>
        {loading && !loaded ? (
          <Spinner />
        ) : (
          <React.Fragment>
            <BackNavigation className={styles.back} />
            <div className={styles.intro}>
              <h3 className={styles.title}>{t('moderationReport.title')}</h3>
              <p className={styles.description}>{t('moderationReport.description')}</p>
              <blockquote className={styles.blockquote}>{t('moderationReport.blockquote')}</blockquote>
              {moderation_rights.includes('workplace_moderation') ||
              moderation_rights.includes('group_mixr_moderation') ? (
                <div className={styles.moderationTabs}>
                  <Tabs
                    type='boxed'
                    initialActive={activeTab}
                    contentClassName={styles.tabContent}
                    hasCountInLabel={true}>
                    <div
                      onClick={() => handleSetActiveTab(0, 'workplace_activity')}
                      label={`${t('moderationReport.tabs.workplace_activity')} (${
                        moderation_stats.tab.workplace_activity.total
                      })`}
                      hidden={!moderation_rights.includes('workplace_moderation')}>
                      <WorkplaceActivity
                        filter={filter}
                        setFilter={setFilter}
                        searchText={searchText}
                        setSearchText={setSearchText}
                      />
                    </div>
                    <div
                      onClick={() => handleSetActiveTab(1, 'awaiting_review')}
                      label={`${t('moderationReport.tabs.awaiting_review')} (${
                        moderation_stats.tab.awaiting_review.total
                      })`}>
                      <AwaitingReview searchText={searchText} setSearchText={setSearchText} />
                    </div>
                    <div
                      onClick={() => handleSetActiveTab(2, 'history')}
                      label={`${t('moderationReport.tabs.history')} (${moderation_stats.tab.history.total})`}
                      hidden={!moderation_rights.includes('group_mixr_moderation')}>
                      <ReviewHistory searchText={searchText} setSearchText={setSearchText} />
                    </div>
                  </Tabs>
                </div>
              ) : (
                <ErrorMessage text={error.message} className={styles.error} />
              )}
            </div>
          </React.Fragment>
        )}
      </div>
    </PageContainer>
  )
}

export { ModerationReportPage }
